import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EditContainerRoutes } from './edit-container.routing';

@NgModule({
  declarations: [],
  imports: [CommonModule, EditContainerRoutes],
})
export class EditContainerModule {}
